import gql from "graphql-tag";

export const CONTENT_QUERY = gql`
  query CONTENT_QUERY {
    myRegistrations {
      id
      sanityEventId
    }
  }
`;

export const REGISTER_TO_EVENT = gql`
  mutation($eventId: ID!, $currentLang: String!, $eventType: String!) {
    registerToEvent(
      eventId: $eventId
      currentLang: $currentLang
      eventType: $eventType
    ) {
      sentMail
      registration {
        id
      }
    }
  }
`;

export const UNREGISTER_FROM_EVENT = gql`
  mutation($eventId: ID!, $currentLang: String!, $eventType: String!) {
    unregisterFromEvent(
      eventId: $eventId
      currentLang: $currentLang
      eventType: $eventType
    ) {
      id
    }
  }
`;
